// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import polyfill from 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import axios from 'axios'
import request from './common/request.js'
import echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'  //common.js中另一种方法引入bmap跟echares联动
import * as tools from '@/common/validate'
import * as common from '@/common/common'
import VueCropper from 'vue-cropper'
import Clipboard from 'clipboard';
import router from './router'
import VueCookies from 'vue-cookies'
import i18n from './assets/lang/index'
import animated  from  'animate.css'
import Directives from './common/directives'
import  mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(mavonEditor)
Vue.prototype.configUrl =window.config.url;
Vue.prototype.ImgUrl =window.config.ImgUrl;
Vue.prototype.FooterFont =window.config.FooterFont;
Vue.prototype.domain =window.config.domain;



request.init();
Vue.use(Directives)
Vue.use(polyfill);
Vue.use(VueCropper);//引入图片裁剪
Vue.use(ElementUI, {
  i18n : (key,val)=>i18n.t(key,val)
})
Vue.use(VueCookies);
Vue.use(BaiduMap, {
  ak: 'K8FGD0d4S4qlo4MsZb5musrUSbG1Ps2G'  //这个地方是官方提供的ak密钥
})
Vue.use(animated)

Vue.prototype.USERINFO='';
Vue.prototype.$tools = tools;
Vue.prototype.$common = common;
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios;
Vue.prototype.clipboard = Clipboard;//引入复制粘贴
Vue.config.productionTip = false

Vue.POWER = [];

router.beforeEach(function (to, from, next) {
  Vue.POWER = [];
  console.log(to);
  if(to.name=='login'){
    next();
  }
  // document.title = to.meta.title;
  let PowerUrlAry = [];


  axios.get(Vue.prototype.configUrl+'/Permission/PermissionList', {
    params: {
      siteguid: '12193032-2D60-6F2B-1944-B707D8D7E7A9', ispower: true
    }
  })
    .then(function (response) {

      let ary = JSON.parse(response.data).results.rows;
      ary.forEach(item => {
        Vue.POWER.push(item.guid);
      });





      axios.get(Vue.prototype.configUrl+"/Permission/PermissionList", {
        params: {
          siteguid: '12193032-2D60-6F2B-1944-B707D8D7E7A9', ispower: ''
        }
      })
        .then(res => {
          let data='';
          if (res.data instanceof Object) {
            data = res.data
          } else {
            data = JSON.parse(res.data)
          }

          if(data.status=='101'){
            return  ;
          }

          data.results.rows.forEach(item => {
            if (item.url != '') {
              PowerUrlAry.push(item.url);
            }
          })
          PowerUrlAry.push('/404/Page404'); //404页面
          PowerUrlAry.push('/print/DevPdf');
          PowerUrlAry.push('/data');
          PowerUrlAry.push('/dev/DevPdf');
          PowerUrlAry.push('/logistical/LogisticalFindInfo'); //运单详情
          PowerUrlAry.push('/map');
          PowerUrlAry.push('/devmap');
          PowerUrlAry.push('/monmap');
          PowerUrlAry.push('/DevViewAll');
          PowerUrlAry.push('/DevViewAll18');
          PowerUrlAry.push('/usefInfo');
          PowerUrlAry.push('/login');
          PowerUrlAry.push('/type');

          PowerUrlAry.push('/companybundle/index');
          PowerUrlAry.push('/companybundle/noplatuser');
          PowerUrlAry.push('/companybundle/platuser');
          PowerUrlAry.push('/companyAdmin/CompanyAdd');
          PowerUrlAry.push('/companyAdmin/Company');
          PowerUrlAry.push('/companyAdmin/CompanyEdit');
          PowerUrlAry.push('/companyAdmin/DeptList');
          PowerUrlAry.push('/User');
          PowerUrlAry.push('/UserEdit');
          PowerUrlAry.push('/UserAdd');
          PowerUrlAry.push('/Permission');
          PowerUrlAry.push('/PermissionAdd');
          PowerUrlAry.push('/PermissionEdit');
          PowerUrlAry.push('/PermissionGroup');
          PowerUrlAry.push('/PermissionGroupAdd');
          PowerUrlAry.push('/PermissionGroupEdit');

          if (PowerUrlAry.indexOf(to.path) == -1) {

            next('/Index');
          } else {
            next();
          }
        })

    })


    .catch(err => {

    });


}) //在进入路由之前都会执行一次此方法，全局钩子函数，可以添加拦截功能


/* eslint-disable no-new */
window.vm=new Vue({
  el: '#app',
  router,
  i18n,//将VueI18n挂载到vue实例上
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js